const RECOVERY_BLOCKED_KEY = "auth:recovery-blocked";
let recoveryBlocked = false;

export function blockAutomaticRecovery(): void {
  recoveryBlocked = true;
  try { sessionStorage.setItem(RECOVERY_BLOCKED_KEY, "true"); } catch { /* Memory fallback. */ }
}

export function clearRecoveryBlock(): void {
  recoveryBlocked = false;
  try { sessionStorage.removeItem(RECOVERY_BLOCKED_KEY); } catch { /* Memory fallback. */ }
}

export function automaticRecoveryBlocked(): boolean {
  try { return recoveryBlocked || sessionStorage.getItem(RECOVERY_BLOCKED_KEY) === "true"; }
  catch { return recoveryBlocked; }
}
